"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFFLUENT_PATH_TYPE = exports.ACCEPTABLE_COVERAGE = exports.EFFLUENT_PATH_DEFAULT_RANGE = void 0;
exports.EFFLUENT_PATH_DEFAULT_RANGE = 20;
exports.ACCEPTABLE_COVERAGE = 0;
var EFFLUENT_PATH_TYPE;
(function (EFFLUENT_PATH_TYPE) {
    EFFLUENT_PATH_TYPE["LateralEffluentSpreader"] = "Lateral Effluent Spreader";
    EFFLUENT_PATH_TYPE["PivotEffluentSpreader"] = "Pivot Effluent Spreader";
})(EFFLUENT_PATH_TYPE || (exports.EFFLUENT_PATH_TYPE = EFFLUENT_PATH_TYPE = {}));
